import { useState } from "react";
import { Modal, Typography } from "antd";
import { HelpCircle } from "lucide-react";
import ReactMarkdown from "react-markdown";

function PageDocumentation({ docKey }) {
  const [open, setOpen] = useState(false);
  const [docs, setDocs] = useState(null);

  const loadDocs = async () => {
    try {
      const data = await import(`../docs/${docKey}.json`);
      setDocs(data.default);
      setOpen(true);
    } catch (error) {
      console.error("Error loading documentation:", error);
    }
  };

  return (
    <>
      <HelpCircle
        size={20}
        className="text-blue-500 hover:text-blue-700 cursor-pointer"
        onClick={loadDocs}
      />
      <Modal
        title={docs?.title}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={700}
      >
        <div className="max-h-[70vh] overflow-y-auto pr-2">
          {docs?.sections?.map((section, i) => (
            <div key={i} className="mb-4">
              <Typography.Title level={5}>{section.title}</Typography.Title>
              <div className="prose prose-sm max-w-none">
                <ReactMarkdown>{section.content}</ReactMarkdown>
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}

export default PageDocumentation;
